import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { STUDENT_FEATURE_KEY } from './keys';
import { studentReducer } from './reducers/student.reducer';
import { StudentEffects } from './effects/student.effects';
import { Student_StudentsEffects } from './bridge/student_students.effects';
import { AdminStudent_StatisticsEffects } from './bridge/adminStudent_statistics.effects';

export const adminStudentStoreProviders = [
    provideState(STUDENT_FEATURE_KEY, studentReducer),
    provideEffects(StudentEffects, Student_StudentsEffects, AdminStudent_StatisticsEffects),
];

export { StudentFacade } from './facades/student.facade';
export { studentCleanup } from './guards/cleanup.guard';
